<template>
	<div>
		<div v-if="error" class="alert alert-danger">
			{{error}}
		</div>
		<div class="row">
			<div class="col-6 text-center">
				<div>
					<img :src="icon">
					<div class="description">
						{{description}}
					</div>
				</div>

				<div class="temp">
					{{convertedTemperature}}&deg; <sup>{{tempUnit}}</sup>
				</div>
			</div>
			<div class="col-6">
				<h2>Details</h2>

				<table class="tiny-table">
					<tr>
						<td colspan="2" class="text-muted">
							As of {{datetime}}
						</td>
					</tr>
					<tr>
						<th>Location:</th>
						<td>{{location}}</td>
					</tr>
					<tr>
						<th>Wind:</th>
						<td>{{convertedWindSpeed}} {{speedUnit}} from {{windDir}}</td>
					</tr>
					<tr>
						<th>Visbility:</th>
						<td>{{visibility}} {{distanceUnit}}</td>
					</tr>
					<tr>
						<th>Humidity:</th>
						<td>{{humidity}}%</td>
					</tr>
					<tr>
						<th>Cloud Cover:</th>
						<td>{{cloudCoverName}}</td>
					</tr>
				</table>
			</div>
		</div>
		<div v-if="showWarnings">
			<div v-if="warnings.heat" class="alert alert-danger">
				<i class="fa fa-fw fa-thermometer-full"></i>
				Heat warning
			</div>
			<div v-if="warnings.cold" class="alert alert-primary">
				<i class="fa fa-fw fa-snowflake"></i>
				Cold temperatures
			</div>
			<div v-if="warnings.rain" class="alert alert-primary">
				<i class="fa fa-fw fa-cloud-showers-heavy"></i>
				Wet weather
			</div>
			<div v-if="warnings.wind" class="alert alert-warning">
				<i class="fa fa-fw fa-superpowers"></i>
				High winds
			</div>
			<div v-if="warnings.storm" class="alert alert-warning">
				<i class="fa fa-fw fa-bolt"></i>
				Storm warning
			</div>
		</div>
	</div>
</template>

<style type="text/css" scoped>

	.description {
		font-size: 14pt;
		font-weight: bold;
		display: inline-block;
		margin-left: 10px;
		margin-right: 10px;
	}

	.temp {
		font-size: 36pt;
		font-weight: bold;
	}

	h2 {
		font-size: 12pt;
		font-weight: bold;
		text-decoration: underline;
		margin-bottom: 5px;
	}

	.tiny-table {
		font-size: 10pt;
	}

	.alert {
		padding: 5px;
		margin-bottom: 5px;
	}
</style>

<script type="text/javascript">
export default {
	name: "WeatherWidget",
	props: [
		"historical", //pass in wx object, which matches data() object
		"lat",
		"lon",
		"q", //q query instead of lat/long
		"showWarnings" //ex. show 'cold weather warning'
	],
	data() {
		return {
			apiKey: "3593e8926b7eb381853df94857f23b53",
			celcius: null,
			wind: {
				speed: null,
				deg: null
			},
			cloudCover: null,
			icon: null,
			description: null,
			visibility: null,
			humidity: null,
			location: "",
			rain: {},
			datetime: null,
			error: false
		}
	},
	watch: {
		lat() {
			this.getWeather()
		},
		lon() {
			this.getWeather()
		},
		q() {
			this.getWeather()
		},
		historical() {
			let vm = this

			Object.keys(this.historical).forEach(key => {
				vm[key] == vm.historical[key]
			})
		}
	},
	computed: {
		convertedTemperature() {
			if (this.companyIsAmerican) {
				let f = +this.celcius * (9/5) + 32
				return f.round(0)
			}
			return this.celcius
		},
		convertedWindSpeed() {
			if (this.companyIsAmerican) {
				let ws = +this.wind.speed / 1.61
				return ws.round(0)
			}
			return this.wind.speed
		},
		tempUnit() {
			if (this.companyIsAmerican)
				return "F"
			return "C"
		},
		speedUnit() {
			if (this.companyIsAmerican)
				return "mph"
			return "km/h"
		},
		distanceUnit() {
			if (this.companyIsAmerican)
				return "mi"
			return "km"	
		},
		warnings() {
			let warnings = {
				heat: false,
				storm: false,
				cold: false,
				rain: false,
				wind: false
			}

			if (this.celcius > 25)
				warnings.heat = true

			if (this.celcius < -5)
				warnings.cold = true

			if (this.wind && "speed" in this.wind && this.wind.speed > 50)
				warnings.wind = true

			if ("1h" in this.rain && this.rain["1h"] > 5)
				warnings.rain = true

			return warnings
		},
		cloudCoverName() {
			if (this.cloudCover == 0)
				return "Clear"
			else if (this.cloudCover <= 12.5)
				return "Few"
			else if (this.cloudCover <= 50)
				return "Scattered"
			else if (this.cloudCover <= 87.5)
				return "Broken"
			else return "Overcast"
		},
		windDir() {
			if (this.wind.deg >= 338 || this.wind.deg < 23)
				return "N"
			else if (this.wind.deg < 68)
				return "NE"
			else if (this.wind.deg < 113)
				return "E"
			else if (this.wind.deg < 158)
				return "SE"
			else if (this.wind.deg < 203)
				return "S"
			else if (this.wind.deg < 248)
				return "SW"
			else if (this.wind.deg < 292)
				return "W"
			else if (this.wind.deg < 338)
				return "NW"
				
		}
	},
	methods: {
		setWeather(data) {
			let vm = this

			if (typeof data == 'string') {
				try {
					data = JSON.parse(data)
				}
				catch (e) {
					data = {}
				}
			}

			if ("error" in data)
				this.error = data.error

			vm.celcius = ""
			vm.humidity = ""
			if (data.main) {

				if ("temp" in data.main)
					vm.celcius = Math.round(data.main.temp - 273)
						
				vm.humidity = "humidity" in data.main ? data.main.humidity : ""
			}

			vm.wind = false

			if ("wind" in data)
				vm.wind = data.wind

			if ('rain' in data)
				vm.rain = data.rain

			vm.visibility = Math.round(data.visibility / 1000) //km

			if (data.clouds)
				vm.cloudCover = data.clouds.all //% coverage
			
			vm.location = data.name

			vm.datetime = this.moment(data.dt*1000).format("h:mm a MMM D, YYYY")

			vm.description = ""
			if (typeof data.weather != 'undefined' && data.weather.length > 0) {
				vm.description = data.weather.map(wx => {
					return wx.main
				}).join(", ")

				vm.icon = "https://openweathermap.org/img/w/"+data.weather[0].icon+".png"
			}

		},
		getWeather() {
			let vm = this

			if (!this.historical) {

				let params = {}

				if (this.lat && this.lon) {
					params.lat = this.lat,
					params.lon = this.lon
				}
				else if (this.q)
					params.q = this.q

				this.getJSON("Weather/current",params,true).then(response => {

					if (response.success) {

						this.$emit("weatherFetched",response.data)

						let data = JSON.parse(response.data)

						vm.setWeather(data)

					}
				})
			}
			else 
				vm.setWeather(this.historical)
		}
	},
	created() {

		if ((this.lat && this.lon) || this.q || this.historical)
			this.getWeather()
		else
			this.$emit("weatherFetched",{error: 'No location provided'})

	}
}
</script>